import {Component, OnInit} from '@angular/core';
import {TranslateService} from "../../../services/translate.service";
import {CardsContent} from "../news/news.component";

@Component({
    selector: 'app-whoelse',
    templateUrl: './whoelse.component.html',
    styleUrls: ['./whoelse.component.css']
})
export class WhoelseComponent implements OnInit {

    allWhoElseEng: CardsContent [] = [
        {
            title: 'Reasons why you should become top1 psychologist and psychotherapist in your life',
            date: '',
            avatar: '', alink: '',
            images: [],
            text: [
                '',
                '• a lot of psy-cases you must handle a day - don\'t call psychotherapist every time',
                '• • internal cases - not to let symptoms inside your psyche be triggered',
                '• • external cases - not to let others make you psychic trauma intentionally or accidentally',
                '• • external cases - not to let others cause reflecting or associative symptoms in your psyche intentionally or accidentally',
                '• • a lot ...'
            ],
            links: []
        },
        {
            title: '',
            date: '',
            avatar: '', alink: '',
            images: [],
            text: [
                '• plan, configure and reconfigure on demand of situation your internal psychic energy - can\'t call your psy-coach or psychotherapist',
                '• prepare plan and act communication processes with ppl who called energetic vampires - AHM classifications simply handle it, u decide where to direct your psy energy',
                '• filter modify and block advices from psychologists with or without different diplomas - the same advice may trigger very different or opposite processes inside different type of psyche, usually this top moment ignored',
                '• trust full to other people usually big mistake - easy weapon for bad ppl, trust only things necessary for psychoanalysis',
                '• make out who is good and who is bad psychologist easy even with beginner level of own psychoanalysis - don\'t think your psychoanalysis good by default',
                '• many ppl today kings of their life, psychology - primary armament of king any type'
            ],
            links: []
        },
        {
            title: 'Who must make decisions according to all points above?',
            date: '',
            avatar: '', alink: '',
            images: [],
            text: [
                '',
                'Only you!'
            ],
            links: []
        }
    ];

    allWhoElseRus: CardsContent [] = [
        {
            title: 'Причины, почему вы должны стать топ-1 психологом и психотерапевтом в вашей жизни',
            date: '',
            avatar: '', alink: '',
            images: [],
            text: [
                '',
                '• много пси-кейсов, с которыми вы должны справиться за день, а не звонить каждый раз психотерапевту',
                '• • внутренние случаи - не допустить появления симптомов в вашей психике',
                '• • внешние случаи - не позволять другим преднамеренно или случайно причинить вам психическую травму',
                '• • внешние случаи - не позволять другим преднамеренно или случайно вызывать рефлексирующие или ассоциативные симптомы в вашей психике',
                '• • много ...'
            ],
            links: []
        },
        {
            title: '',
            date: '',
            avatar: '', alink: '',
            images: [],
            text: [
                '• планируйте, настраивайте и перенастраивайте по мере необходимости вашу внутреннюю психическую энергию - не можете звонить своему пси-коучу или психотерапевту постоянно',
                '• готовьте план и управляйте процессами общения с людьми, которых называют энергетическими вампирами - классификация АЧП просто справляется с этим, вы сами решаете, куда направить свою психическую энергию',
                '• фильтруйте, изменяйте и блокируйте советы психологов с разными дипломами или без них - один и тот же совет может вызывать очень разные или противоположные процессы внутри разного типа психики, обычно этот главный момент игнорируется',
                '• полное доверие к другим людям, как правило, большая ошибка - легкое оружие для плохих людей, доверять только моменты, необходимые для психоанализа',
                '• легко разобраться, кто хороший, а кто плохой психолог, даже с психоанализом начального уровня - не думайте, что ваш психоанализ по умолчанию хорош',
                '• многие люди сегодня короли своей жизни, психология - первичное вооружение короля любого типа'
            ],
            links: []
        },
        {
            title: 'Кто должен принимать решения по всем пунктам выше?',
            date: '',
            avatar: '', alink: '',
            images: [],
            text: [
                '',
                'Только вы!'
            ],
            links: []
        }
    ];

    constructor(private translate: TranslateService) {
    }

    ngOnInit() {
    }

    goLink(link: string) {
        setTimeout(() => {
            window.open(link, '_blank');
        }, 300);
    }


}
